import { ExternalLink } from "lucide-react";

const paths = [
  {
    label: "Learn to Build",
    href: "https://freshvisionacademy.org/real-estate",
    body: "Step-by-step training that teaches you how the systems work, so you can build your own follow-up, lead routing, and content workflows and change them whenever your business changes.",
    cta: "Start learning",
  },
  {
    label: "Build With Us",
    href: "https://freshvisionacademy.org/real-estate#re-deploy",
    body: "Guided implementation alongside people doing the same work. You build your systems live, with feedback, so you leave with something running instead of a folder of notes.",
    cta: "Build with support",
  },
];

const ImplementationPaths = () => (
  <section id="implementation-paths" className="py-20 md:py-28 bg-[#F1EEE4]">
    <div className="container mx-auto px-6">
      <div className="text-center mb-12 max-w-2xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold mb-4 leading-tight text-[#0A192F]">
          Choose Your Level of Implementation
        </h2>
        <p className="text-[#0A192F]/75 text-base md:text-lg">
          Learn to build it, or build it with support.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto">
        {paths.map((p) => (
          <a
            key={p.label}
            href={p.href}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col bg-white border border-[#C5A059]/30 rounded-xl p-7 hover:border-[#C5A059] hover:shadow-[0_10px_40px_-15px_rgba(10,25,47,0.25)] hover:-translate-y-1 transition-all duration-300"
          >
            <h3 className="text-xl md:text-2xl font-bold mb-3 text-[#0A192F] leading-snug">
              {p.label}
            </h3>
            <p className="text-[#0A192F]/75 text-sm md:text-[15px] leading-relaxed mb-6 flex-1">
              {p.body}
            </p>
            <span className="inline-flex items-center gap-1.5 text-[hsl(var(--accent-strong))] font-semibold text-sm group-hover:gap-2.5 transition-all">
              {p.cta}
              <ExternalLink className="w-3.5 h-3.5" strokeWidth={2} />
            </span>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default ImplementationPaths;
